<script lang="ts">
    import {employeeStatus} from "$lib/options";
    import {Select, Tooltip} from "flowbite-svelte";
    import {enhance} from "$app/forms";
    import type {Writable} from "svelte/store";
    import {getContext, onMount} from "svelte";
    import CardLayoutSubmitButton from "$items/employee/form/CardLayoutSubmitButton.svelte";
    import CopyToClipboard from "$lib/components/CopyToClipboard.svelte";
    import {LinkOutline} from "flowbite-svelte-icons";
    import {PUBLIC_RECRUITING_APP} from "$env/static/public";
    export let status: string = 'inactive';
    export let size: string = 'xs';

    export let uuid: string;

    export let loading = false;
    export let editable = false;
    let trigger_submits: Writable<Set<HTMLButtonElement | HTMLFormElement>> = getContext("trigger_submits");

    onMount(() => {
        $trigger_submits.add(form_to_submit)
    });

    let statusColor: 'red' | 'green' | 'yellow' = 'red';
    $: statusText = employeeStatus[status as keyof typeof employeeStatus];
    let applyLink = null;
    $: {
        statusColor = 'yellow';
        applyLink = null;
        if (status === 'active') {
            statusColor = 'green';
        } else if (status === 'inactive') {
            statusColor = 'red';
        } else if(status === 'interviewee' || status === 'training-session' || status === 'data-verified'){
            applyLink = PUBLIC_RECRUITING_APP + '/schedule?sheet=' + uuid;
        }else if(status === 'data-requested' || status === 'data-provided' || status === 'data-re-requested' || status === 'data-re-provided'){
            applyLink = PUBLIC_RECRUITING_APP + '/data-request?sheet=' + uuid;
        }
    }

    let form_to_submit: HTMLFormElement;
</script>

<form bind:this={form_to_submit} action="?/update_employee_status" method="post"
      use:enhance={() => {loading=true;return ({ update }) => {loading=false; update({ reset: false })}}}>
    {#if editable}
        <div class="flex items-center gap-2">
            <Select name="status" {size}
                    bind:value={status} items={Object.entries(employeeStatus).map((n) => ({value: n[0], name: n[1]}))}/>
            <CardLayoutSubmitButton/>
        </div>

    {:else}
      <span class="inline-flex items-center gap-x-1.5 px-1 rounded-md text-neutral-600">
        <!--<svg class="h-1.5 w-1.5 fill-{statusColor}-500" viewBox="0 0 6 6" aria-hidden="true">
          <circle cx="3" cy="3" r="3"/>
        </svg>-->
          {statusText}
          {#if applyLink}
              <div>
                  <CopyToClipboard textToCopy={applyLink}>
                    <LinkOutline/>
                  </CopyToClipboard>
              </div>
            <Tooltip>{applyLink}</Tooltip>
          {:else if status === 'rebuddy' }
              <div>
                  <CopyToClipboard textToCopy={'https://calendly.com/work-nks/recrew-rebuddy-get-together'}>
                    <LinkOutline/>
                  </CopyToClipboard>
              </div>

          {/if}
      </span>

    {/if}
</form>
